// extracted by mini-css-extract-plugin
export default {"Skeleton":"_4ps8xR7m"};